import { HttpTypes } from '@medusajs/types';
import { Table } from '@medusajs/ui';
import { useSearchParams } from 'react-router-dom';

import repeat from '@lib/util/repeat';
import Item from '@modules/cart/components/item';
import SkeletonLineItem from '@modules/skeletons/components/skeleton-line-item';

interface ItemsTemplateProps {
  items?: HttpTypes.StoreCartLineItem[];
  showImg?: boolean;
  showIdx?: boolean;
}

const ItemsTemplate = ({
  items,
  showImg = true,
  showIdx = false,
}: ItemsTemplateProps) => {
  const [searchParams] = useSearchParams();
  const step = searchParams.get('step');

  return (
    <div className="bg-white-10 max-h-[420px] overflow-auto">
      <Table>
        <Table.Header className="border-t-0">
          <Table.Row className="txt-medium-plus text-ui-fg-subtle overflow-hidden rounded-md">
            {showIdx && (
              <Table.HeaderCell className="text-grey-60">#</Table.HeaderCell>
            )}

            <Table.HeaderCell className="text-grey-60 whitespace-nowrap rounded-tl-md">
              商品資訊
            </Table.HeaderCell>
            {showImg && (
              <Table.HeaderCell className="text-grey-60"></Table.HeaderCell>
            )}
            <Table.HeaderCell className="text-grey-60">價格</Table.HeaderCell>
            {step === '1' ? (
              <>
                <Table.HeaderCell className="text-grey-60 whitespace-nowrap pr-0 text-center">
                  商品狀態
                </Table.HeaderCell>
                <Table.HeaderCell className="text-grey-60 rounded-tr-md !pr-0 text-center">
                  操作
                </Table.HeaderCell>
                <Table.HeaderCell className="text-grey-60 rounded-tr-md text-right">
                  小計
                </Table.HeaderCell>
              </>
            ) : (
              <>
                <Table.HeaderCell className="text-grey-60 text-center">
                  數量
                </Table.HeaderCell>
                <Table.HeaderCell className="text-grey-60 rounded-tr-md text-right">
                  小計
                </Table.HeaderCell>
              </>
            )}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {items
            ? items
                .sort((a, b) => {
                  return String(a.created_at ?? '') > String(b.created_at ?? '')
                    ? 1
                    : -1;
                })
                .map((item, idx) => {
                  return (
                    <Item
                      key={item.id}
                      item={item}
                      step={step}
                      showImg={showImg}
                      showIdx={showIdx}
                      idx={idx}
                    />
                  );
                })
            : repeat(5).map((i) => {
                return <SkeletonLineItem key={i} />;
              })}
        </Table.Body>
      </Table>
    </div>
  );
};

export default ItemsTemplate;
